import { PaginateQuery } from "resources/types/shared";
import { RelatorioBaseData } from "core/features/relatorios/typings";

export enum TipoConsumoEnum {
  Agua = "FAD477BD-0E21-4D0E-8AF4-092EC3CB0001",
  Gas = "FAD477BD-0E21-4D0E-8AF4-092EC3CB0000",
  Energia = "FAD477BD-0E21-4D0E-8AF4-092EC3CB0003",
  AguaMineral = "FAD477BD-0E21-4D0E-8AF4-092EC3CB0002",
  Esgoto = "FAD477BD-0E21-4D0E-8AF4-092EC3CB0004",
}

export enum ConsumoUnidadeMedidaEnum {
  Litros = "L",
  MetrosCubicos = "m3",
  Kilos = "kg",
  KilowattHora = "kWh",
}

export interface ConsumoDto extends FormFaixaConsumo {
  id: string;
  mes: string;
  unidadeMedida: ConsumoUnidadeMedidaEnum;
  tipoConsumoId: TipoConsumoEnum;
  observacao: string;
  diaMedicao: number | null;
  valorUnidade: number | null;
  consumoAnteriorId: string | null;
}

export enum FaixaConsumoTipoValorEnum {
  UnidadeMedida = "unidade-medida",
  ValorFixo = "valor-fixo",
}
export interface FaixaConsumoDto {
  id?: string;
  tempId?: string;
  valor: number;
  inicioFaixa?: number | null;
  fimFaixa?: number | null;
  tipoValor: FaixaConsumoTipoValorEnum | null;
}

export interface FormFaixaConsumo {
  faixas: FaixaConsumoDto[];
}

export interface ConsumoDashboardDto {
  totalConsumo: number;
  unidadesComMedida: number;
  totalUnidades: number;
  somaTotal: number;
  valorCobradoTotal: number;
}
export interface ConsumoUnidade {
  consumoId: string;
  unidadeId: string;
  medidaAtual: number | null;
  numero: string;
  blocoQuadra: string | null;
  consumoUnidadeMesAnterior: number | null;
}

export type PdfConsumoUnidadeResponse = RelatorioBaseData & {
  items: ConsumoUnidade[];
};

export interface ConsumoQueryParams extends PaginateQuery {
  search?: string;
  tipoConsumoId?: TipoConsumoEnum;
  mes?: string;
}

export interface ConsumoPdfQueryParams {
  search?: string;
  tipoConsumoId?: TipoConsumoEnum;
  mes?: string;
}

export interface ConsumoForm extends Omit<ConsumoDto, "totalConsumo"> {
  unidades: Record<string, number>;
}

export interface EditarConsumoForm extends FormFaixaConsumo {
  diaMedicao: number | null;
  valorUnidade: number | null;
  replicarValorMesesFuturos?: boolean;
}

export interface EditarTenantTipoConsumoForm {
  unidadeMedida: ConsumoUnidadeMedidaEnum;
  tipoConsumoId: TipoConsumoEnum;
}

export interface ImportarConsumoUnidades {
  unidades: Record<string, number>;
}
export interface EditarConsumoUnidadeForm {
  medidaAtual: number;
}

export const mapUnidadeMedidaExtenso: Record<ConsumoUnidadeMedidaEnum, string> =
  {
    [ConsumoUnidadeMedidaEnum.Kilos]: "kilo",
    [ConsumoUnidadeMedidaEnum.KilowattHora]: "killowatt-hora",
    [ConsumoUnidadeMedidaEnum.Litros]: "litro",
    [ConsumoUnidadeMedidaEnum.MetrosCubicos]: "metro cúbico",
  };
